import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "channel-inapp",
  "use": "channel-inapp-usage",
  "viewBox": "0 0 20 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 24\" id=\"channel-inapp\"><path d=\"M13 15v5.518a2.732 2.732 0 01-2.733 2.732H3.733A2.732 2.732 0 011 20.518V4.983A2.733 2.733 0 013.733 2.25H7m-6 16.5h12m.75-18A3.75 3.75 0 0117.5 4.5v3A1.5 1.5 0 0019 9H8.5A1.5 1.5 0 0010 7.5v-3A3.75 3.75 0 0113.75.75z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/channel-inapp.svg
// module id = F2fA
// module chunks = 39 44